import React, { useEffect, useMemo, useCallback, useRef } from "react";
import { capitalize } from "../../../utils/stringUtils";
// import { dashboard_vertical_three_dots } from "../../../assets/images";
// import CreateProduct from "../../../components/MerchantDashboard/CreateProduct";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import "./serviceList.css";
import "./styleCustom.css";
// import "../aflhome/styleafl.css";
import { useMutation } from "@tanstack/react-query";
import axiosInstance from "../../../services/axios.instance";
import { API_URL } from "../../../services/apiConfig";
import { useState } from "react";
import {
  // Car,
  // ProductList,
  ProductDelete,
  // ApiResponse,
  AflApiResponse,
  ExportList,
} from "../../../types";

import {
  Button,
  Card,
  CardBody,
  Col,
  Dropdown,
  Form,
  FormControl,
  Pagination,
  Row,
} from "react-bootstrap";
import AFLConfirmationModal from "./../../../components/AFL/AFLConfirmationModal";
import MoreVertIcon from "@mui/icons-material/MoreVert";
// import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import * as XLSX from "xlsx";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const ServiceList = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const [selectedStatus, setSelectedStatus] = useState("PENDING");
  const [serviceList, setServiceList] = useState<AflApiResponse | null>(null);

  const currentPage = parseInt(searchParams.get("page") || "0", 10);
  const pageSize = parseInt(searchParams.get("size") || "10", 10);
  const [totalPages, setTotalPages] = useState(1);
  const [searchResults, setSearchResults] = useState<AflApiResponse | null>(
    null
  );

  const [searchCriteria, setSearchCriteria] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [hasSearched, setHasSearched] = useState(false);

  // Function to handle export button click
  const handleExportClick = () => {
    navigate("/dashboard/servicelist/exportFile");
  };

  // Reset search query and results when changing search criteria
  const handleSearchCriteriaChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setSearchCriteria(e.target.value);
    setSearchQuery("");
    setStartDate(null);
    setEndDate(null);
    setSearchResults(null);
    setHasSearched(false);
  };
  const [currentSearchPage, setCurrentSearchPage] = useState(0);

  // const [showCreateProduct, setShowCreateProduct] = useState(false);
  const accessToken = localStorage.getItem("access_token");

  const decodeToken = (token: any) => {
    if (token) {
      return JSON.parse(atob(token.split(".")[1]));
    } else {
      return null;
    }
  };

  const decodedToken = decodeToken(accessToken);
  const [isAAAUser, setIsAAAUser] = useState(false);
  const [isAFLUser, setIsAFLUser] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    const decoded = decodeToken(token);
    const roles = decoded?.roles || [];
    if (roles.includes("ROLE_AAA_USER")) {
      setIsAAAUser(true);
    }
    if (roles.includes("ROLE_AFL_USER")) {
      setIsAFLUser(true);
    }
  }, []);

  // const merchantId =
  //   decodedToken && decodedToken["merchant-id"]
  //     ? decodedToken["merchant-id"]
  //     : null;

  // const businessArea =
  //   decodedToken && decodedToken["planet"] ? decodedToken["planet"] : null;

  const generatePageNumbers = (currentPage: number, totalPages: number) => {
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i);
    }

    if (currentPage <= 3) {
      return [0, 1, 2, 3, -1, totalPages - 2, totalPages - 1];
    }

    if (currentPage >= totalPages - 4) {
      return [
        0,
        1,
        -1,
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
      ];
    }

    return [
      0,
      1,
      -1,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      -1,
      totalPages - 1,
    ];
  };

  const mutation = useMutation({
    mutationFn: (userData: any) =>
      axiosInstance.post(
        `${API_URL.SERVICE_LIST}?page=${currentPage}&size=${pageSize}`,
        userData
      ),

    onSuccess: (successResponse) => {
      setServiceList(successResponse?.data);
      setTotalPages(successResponse?.data?.totalPages);
    },
    onError: (error: any) => {
      if (error?.data?.message) {
        alert(error?.data?.message);
      }
    },
  });

  const initialRender = useRef(true);

  useEffect(() => {
    console.log("ServiceList useEffect triggered:", {
      initialRender: initialRender.current,
      currentPage,
      pageSize,
      searchParams: searchParams.toString(),
      baseUrl: process.env.REACT_APP_BASE_URL,
      apiUrl: API_URL.SERVICE_LIST,
    });

    const fetchData = () => {
      console.log("Calling mutation.mutate with payload:", {
        phone_number: "",
        status: "",
        reference_number: "",
        service_type: "",
        date: "",
      });
      mutation.mutate({
        phone_number: "",
        status: "",
        reference_number: "",
        service_type: "",
        date: "",
      });
    };
    fetchData();

    // Set initialRender to false after first successful data fetch
    if (initialRender.current) {
      console.log("Initial render completed - setting initialRender to false");
      initialRender.current = false;
    }
  }, [currentPage, pageSize, searchParams]);

  //-------------------------------

  const handleSearch = async (
    currentPage: number,
    isNewSearch: boolean = false
  ) => {
    const pageToUse = isNewSearch ? 0 : currentPage;

    const payload: any = {
      reference_number: searchCriteria === "ref_num" ? searchQuery : "",
      status: searchCriteria === "status" ? searchQuery : "",
      service_type: searchCriteria === "service_type" ? searchQuery : "",
      phone_number: searchCriteria === "phone_number" ? searchQuery : "",
    };

    if (searchCriteria === "date") {
      if (startDate) {
        payload.start_date = startDate.toLocaleDateString("en-CA");
      }
      if (endDate) {
        payload.end_date = endDate.toLocaleDateString("en-CA");
      }
    }

    try {
      const response = await axiosInstance.post(
        `${API_URL.SERVICE_LIST}?size=${pageSize}&page=${pageToUse}`,
        payload
      );
      setSearchResults(response.data);
      setHasSearched(true);

      // Update URL parameters if it's a new search
      if (isNewSearch) {
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.set("page", "0");
        setSearchParams(newSearchParams);
        setCurrentSearchPage(0);
      }
    } catch (error) {
      console.error("Error fetching search results", error);
      setHasSearched(false);
    }
  };

  //-----------------------------

  const [visiblePages, setVisiblePages] = useState<number[]>(() => {
    const totalPages = serviceList?.totalPages || 0;
    return generatePageNumbers(0, totalPages);
  });

  const handlePageChange = useCallback(
    (page: number) => {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set("page", page.toString());
      setSearchParams(newSearchParams);
    },
    [searchParams, setSearchParams]
  );

  // Memoize the page numbers generation
  const memoizedGeneratePageNumbers = useCallback(
    (currentPage: number, totalPages: number) => {
      if (totalPages <= 7) {
        return Array.from({ length: totalPages }, (_, i) => i);
      }

      if (currentPage <= 3) {
        return [0, 1, 2, 3, -1, totalPages - 2, totalPages - 1];
      }

      if (currentPage >= totalPages - 4) {
        return [
          0,
          1,
          -1,
          totalPages - 4,
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
        ];
      }

      return [
        0,
        1,
        -1,
        currentPage - 1,
        currentPage,
        currentPage + 1,
        -1,
        totalPages - 1,
      ];
    },
    []
  );

  useEffect(() => {
    if (serviceList?.totalPages) {
      setVisiblePages(
        memoizedGeneratePageNumbers(currentPage, serviceList.totalPages)
      );
    }
  }, [serviceList, currentPage, memoizedGeneratePageNumbers]);

  const [searchVisiblePages, setSearchVisiblePages] = useState<number[]>(() => {
    const totalPages = searchResults?.totalPages || 0;
    return generatePageNumbers(0, totalPages);
  });

  //-----------------------

  useEffect(() => {
    if (searchResults?.totalPages) {
      setSearchVisiblePages(
        generatePageNumbers(currentSearchPage, searchResults.totalPages)
      );
    }
  }, [searchResults, currentSearchPage]);

  // const handleSearchPageChange = (page: number) => {
  //   setSearchPage(page);
  // };
  const handlePageSearchChange = (page: number) => {
    setCurrentSearchPage(page);
    handleSearch(page);
  };

  const handlePageSizeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newPageSize = Number(e.target.value);
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set("size", newPageSize.toString());
    newSearchParams.set("page", "0");
    setSearchParams(newSearchParams);
  };

  //------------------------------------------------------------------
  const [showAcceptConfirmationModal, setShowAcceptConfirmationModal] =
    useState(false);

  const [acceptConfirmationMessage, setAcceptConfirmationMessage] =
    useState("");
  const [selectedOrderId, setSelectedOrderId] = useState<string>("");

  const mutationDelete = useMutation({
    mutationFn: (orderId: string) =>
      axiosInstance.put(`${API_URL.CANCEL_SERVICE}/${orderId}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }),
    onSuccess: (successResponse) => {
      //window.location.reload();
      mutation.mutate({
        //erp_service_number: "",
        phone_number: "",
        status: "",
        reference_number: "",
        service_type: "",
        date: "",
      });
    },
    onError: (error: any) => {
      if (error?.data?.message) {
        alert(error?.data?.message);
      }
      mutation.mutate({
        //erp_service_number: "",
        phone_number: "",
        status: "",
        reference_number: "",
        service_type: "",
        date: "",
      });
    },
  });

  const handleDeleteItem = (orderId: string) => {
    setAcceptConfirmationMessage(
      "Are you sure you want to cancel this service?"
    );
    setShowAcceptConfirmationModal(true);
    setSelectedOrderId(orderId);
    //mutationDelete.mutate(orderId);
  };

  const handleOpenConfirmationModal = (message: string) => {
    setAcceptConfirmationMessage(message);
    setShowAcceptConfirmationModal(true);
  };

  //-------------------------------------------------------------------
  const formatDate = (isoDate: any) => {
    const date = new Date(isoDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  const [selectedCheckboxes, setSelectedCheckboxes] = useState<string[]>([]);

  const location = useLocation();
  const pathname = location.pathname;
  const ordersToDisplay = useMemo(() => {
    if (searchResults?.content) return searchResults.content;
    if (serviceList?.content) return serviceList.content;
    return [];
  }, [searchResults, serviceList]);

  // const handleExport = () => {
  //   //setShowExportDateField(true);
  // };
  //=================================================================

  const [exportServiceList, setExportServiceList] = useState<ExportList | null>(
    null
  );

  //=================================================================

  const handleExportList = async () => {
    const payload: any = {
      reference_number: searchCriteria === "ref_num" ? searchQuery : "",
      status: searchCriteria === "status" ? searchQuery : "",
      service_type: searchCriteria === "service_type" ? searchQuery : "",
      phone_number: searchCriteria === "phone_number" ? searchQuery : "",
    };

    if (searchCriteria === "date") {
      if (startDate) {
        payload.start_date = startDate.toLocaleDateString("en-CA"); // "2025-07-01"
      }
      if (endDate) {
        payload.end_date = endDate.toLocaleDateString("en-CA"); // "2025-07-01"
      }
    }

    try {
      const response = await axiosInstance.post(API_URL.EXPORT_LIST, payload);
      setExportServiceList(response?.data);
    } catch (error) {
      console.error("Error fetching EXPORT results", error);
    }
  };

  const handleExport = () => {
    if (!Array.isArray(exportServiceList) || exportServiceList.length === 0) {
      alert("No data available to export");
      return;
    }

    const formattedData = exportServiceList.map((order, index) => {
      const createdAtFormatted =
        formatDate(order?.aaaServiceRequestModel?.createDate) || "N/A";
      const acceptedDateTime =
        order?.orderView?.order_status_history_responses?.some(
          (status: any) =>
            status.delivery_partner_status === "DELIVERY_ACCEPTED"
        )
          ? formatDate(
              order?.orderView?.order_status_history_responses?.find(
                (status: any) =>
                  status.delivery_partner_status === "DELIVERY_ACCEPTED"
              )?.status_changed_at
            )
          : "N/A";
      const reachedDateTime =
        order?.orderView?.order_status_history_responses?.some(
          (status: any) =>
            status.delivery_partner_status === "REACHED_CUSTOMER_LOCATION"
        )
          ? formatDate(
              order?.orderView?.order_status_history_responses?.find(
                (status: any) =>
                  status.delivery_partner_status === "REACHED_CUSTOMER_LOCATION"
              )?.status_changed_at
            )
          : "N/A";
      const serviceStartDate =
        order?.orderView?.order_status_history_responses?.some(
          (status: any) => status.delivery_partner_status === "SERVICE_STARTED"
        )
          ? formatDate(
              order?.orderView?.order_status_history_responses?.find(
                (status: any) =>
                  status.delivery_partner_status === "SERVICE_STARTED"
              )?.status_changed_at
            )
          : "N/A";
      const completedDateTime =
        order?.orderView?.order_status_history_responses?.some(
          (status: any) => status.delivery_partner_status === "COMPLETED"
        )
          ? formatDate(
              order?.orderView?.order_status_history_responses?.find(
                (status: any) => status.delivery_partner_status === "COMPLETED"
              )?.status_changed_at
            )
          : "N/A";

      const startDates = order?.aaaServiceRequestModel?.comments?.some(
        (comment: { commentStatus: string }) =>
          comment.commentStatus === "dispatch"
      )
        ? formatDate(
            order?.aaaServiceRequestModel?.comments?.find(
              (comment: { commentStatus: string }) =>
                comment.commentStatus === "dispatch"
            )?.createDate
          )
        : "N/A";

      return {
        "S.No": index + 1,
        ReferenceNo: order?.orderServiceDetailsModel?.referenceNumber || "N/A",
        JobOpenDate: formatDate(order?.orderView?.createdAt) || "N/A",
        Status: order?.aaaServiceRequestModel?.state || "N/A",
        CustomerName: order?.orderView?.customer_name || "N/A",
        PlateNo: order?.orderView?.plate_number || "N/A",
        ChasisNo: order?.orderView?.chassis_number || "N/A",
        MobileNo: order?.orderView?.customer_phone_number || "N/A",
        "From Location": order?.orderView?.delivery_location?.address || "N/A",
        "To Location":
          order?.orderView?.recollection_location?.address || "N/A",
        Service: order?.orderServiceDetailsModel?.serviceName || "N/A",
        VehicleMake:
          order?.orderServiceDetailsModel?.vehicleMake ||
          order?.aaaServiceRequestModel?.vehicleMake ||
          "N/A",
        VehicleModel: order?.aaaServiceRequestModel?.vehicleModel || "N/A",
        Comments: order?.orderServiceDetailsModel?.aflComments || "N/A",
        CreatedDateTime: createdAtFormatted,
        AcceptedDateTime: acceptedDateTime,
        StartDateTime: startDates,
        DriverName: order?.orderView?.delivery_boy_details?.firstName || "N/A",
        ReachedDateTime: reachedDateTime,
        ServiceStartDate: serviceStartDate,
        CompletedDateTime: completedDateTime,
        DriverContact:
          order?.orderView?.delivery_boy_details?.phoneNumber || "N/A",
        ReachAndCancel:
          order?.orderServiceDetailsModel?.isDriverReachedAndCancelled,
      };
    });

    try {
      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "ServiceList");
      const filename = `ServiceList_${
        new Date().toISOString().split("T")[0]
      }.xlsx`;
      XLSX.writeFile(workbook, filename);
    } catch (error) {
      console.error("Export failed:", error);
      alert("Failed to export data. Please try again.");
    }
  };
  // Time difference calculation functions
  const formatTime = (hours: number, minutes: number) => {
    if (hours > 0 && minutes > 0) {
      return `${hours} hour(s) ${minutes} minute(s) ago`;
    } else if (hours > 0) {
      return `${hours} hour(s) ago`;
    } else if (minutes > 0) {
      return `${minutes} minute(s) ago`;
    } else {
      return "Just now";
    }
  };

  const timeDifference = (createdAt: string) => {
    if (!createdAt) return { totalMinutes: 0, formatted: "N/A" };

    const now = new Date();
    const createdDate = new Date(createdAt);
    const diffInSeconds = Math.floor(
      (now.getTime() - createdDate.getTime()) / 1000
    );

    const hours = Math.floor(diffInSeconds / 3600);
    const minutes = Math.floor((diffInSeconds % 3600) / 60);
    const totalMinutes = hours * 60 + minutes;

    return { totalMinutes, formatted: formatTime(hours, minutes) };
  };

  // Get star colors based on service order status
  const getStarColors = (serviceOrder: any) => {
    // First star logic
    let firstStarColor = "text-white"; // Default white
    const isInitiateState =
      serviceOrder?.aaaServiceRequestModel?.state === "initiate";

    if (isInitiateState) {
      const timeData = timeDifference(serviceOrder?.orderView?.createdAt);
      firstStarColor =
        timeData.totalMinutes > 10 ? "text-danger" : "text-success";
    } else if (
      serviceOrder?.orderView?.is_dispatched_within_time !== undefined
    ) {
      firstStarColor = serviceOrder.orderView.is_dispatched_within_time
        ? "text-success"
        : "text-danger";
    }

    // Second star - color based on driver reached status time
    const driverReachedTime =
      serviceOrder?.orderView?.order_status_history_responses?.find(
        (status: any) =>
          status.delivery_partner_status === "REACHED_CUSTOMER_LOCATION"
      )?.status_changed_at;

    let secondStarColor = "text-white";
    if (driverReachedTime && serviceOrder?.orderView?.createdAt) {
      const reachedDate = new Date(driverReachedTime);
      const createdDate = new Date(serviceOrder?.orderView?.createdAt);
      const diffInSeconds = Math.floor(
        (reachedDate.getTime() - createdDate.getTime()) / 1000
      );
      const hours = Math.floor(diffInSeconds / 3600);
      const minutes = Math.floor((diffInSeconds % 3600) / 60);
      const totalMinutes = hours * 60 + minutes;
      secondStarColor = totalMinutes < 60 ? "text-success" : "text-danger";
    }

    return { firstStarColor, secondStarColor };
  };

  //==========================================================================
  return (
    <div className="row">
      <Card className="card-bg-afl text-start">
        <CardBody className="px-0 pt-1">
          {/* <h4 className='text-start car_upload_text align-items-center d-flex'>
            <FormatListBulletedIcon style={{ color: "#ed7d31", fontSize: "35px" }} />
            Service List
          </h4> */}
          <div className="col-md-12 px-2">
            <Form.Group
              as={Row}
              className="align-items-center justify-content-between"
            >
              <Col md="8">
                <Row>
                  <Col sm="3">
                    <Form.Select
                      className="select-invoice-bg-black-edit dashboard-poppins-font-style custom-input-afl"
                      aria-label="Select search criteria"
                      value={searchCriteria}
                      onChange={handleSearchCriteriaChange}
                    >
                      <option value="">Search by</option>
                      <option value="ref_num">Reference No.</option>
                      <option value="service_type">Service Type</option>
                      <option value="status">Status</option>
                      <option value="phone_number">Phone No</option>
                      <option value="date">Date</option>
                    </Form.Select>
                  </Col>
                  {searchCriteria && (
                    <>
                      <Col sm="5">
                        {searchCriteria === "status" ? (
                          <Form.Select
                            className="merchant-input-style-create-product custom-input-afl"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                          >
                            <option value="">Select Status</option>
                            <option value="initiate">Initiate</option>
                            <option value="dispatch">Dispatch</option>
                            <option value="start">Start</option>
                            <option value="reach">Reach</option>
                            <option value="completed_by_driver">
                              Completed
                            </option>
                            <option value="done">Done</option>
                            <option value="cancel">Cancelled</option>
                            <option value="reached_and_cancelled">
                              Reached and Cancelled
                            </option>
                          </Form.Select>
                        ) : searchCriteria === "date" ? (
                          <div className="d-flex gap-2 align-items-center">
                            <DatePicker
                              selected={startDate}
                              onChange={(date: Date) => setStartDate(date)}
                              selectsStart
                              startDate={startDate}
                              endDate={endDate}
                              maxDate={endDate || new Date()}
                              className="form-control merchant-input-style-create-product custom-input-afl"
                              dateFormat="dd-MM-yyyy"
                              placeholderText="DD-MM-YYYY"
                              showYearDropdown
                              scrollableYearDropdown
                              yearDropdownItemNumber={15}
                              customInput={
                                <FormControl
                                  value={
                                    startDate
                                      ? `${String(startDate.getDate()).padStart(
                                          2,
                                          "0"
                                        )}-${String(
                                          startDate.getMonth() + 1
                                        ).padStart(
                                          2,
                                          "0"
                                        )}-${startDate.getFullYear()}`
                                      : ""
                                  }
                                  readOnly
                                  className="merchant-input-style-create-product custom-input-afl"
                                />
                              }
                            />
                            <span>to</span>
                            <DatePicker
                              selected={endDate}
                              onChange={(date: Date) => setEndDate(date)}
                              selectsEnd
                              startDate={startDate}
                              endDate={endDate}
                              minDate={startDate}
                              maxDate={new Date()}
                              className="form-control merchant-input-style-create-product custom-input-afl"
                              dateFormat="dd-MM-yyyy"
                              placeholderText="DD-MM-YYYY"
                              showYearDropdown
                              scrollableYearDropdown
                              yearDropdownItemNumber={15}
                              customInput={
                                <FormControl
                                  value={
                                    endDate
                                      ? `${String(endDate.getDate()).padStart(
                                          2,
                                          "0"
                                        )}-${String(
                                          endDate.getMonth() + 1
                                        ).padStart(
                                          2,
                                          "0"
                                        )}-${endDate.getFullYear()}`
                                      : ""
                                  }
                                  readOnly
                                  className="merchant-input-style-create-product custom-input-afl"
                                />
                              }
                            />
                          </div>
                        ) : (
                          <FormControl
                            className="merchant-input-style-create-product custom-input-afl"
                            aria-label="Text input with select"
                            placeholder="Enter your Search"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                          />
                        )}
                      </Col>

                      <Col sm="2">
                        <Button
                          className="btn all_button_style text-black my-1"
                          onClick={async () => {
                            // Pass true as second argument to indicate it's a new search
                            // This will reset pagination to first page
                            await handleSearch(currentPage, true);
                            // Then call handleExportList to prepare export data
                            // await handleExportList();
                          }}
                        >
                          Search
                        </Button>
                      </Col>
                    </>
                  )}

                  {/* {hasSearched && (
                <Row className="d-flex justify-content-end">
                  <Col sm="2">
                    <Button
                      variant="primary"
                      className="btn all_button_style text-black my-1"
                      onClick={handleExport}
                    >
                      Export
                    </Button>
                  </Col>
                </Row>
              )} */}
                </Row>
              </Col>
              <Col sm="2" className="text-end">
                <Button
                  variant="primary"
                  className="btn all_button_style text-black my-1"
                  onClick={handleExportClick}
                >
                  Export
                </Button>
              </Col>
            </Form.Group>
          </div>
          <div className="col-md-12">
            <div className="row pt-2">
              <div className="col-12 dashboard-table-div-afl">
                <table className="table table-hover dashboard-table-afl table-afl">
                  <thead>
                    <tr>
                      {!isAFLUser && <th>Actions</th>}
                      <th>#</th>
                      <th style={{ maxWidth: "100px" }}>Job Ref No</th>
                      <th style={{ maxWidth: "100px" }}>Name</th>
                      <th style={{ maxWidth: "100px" }}>Mobile</th>
                      <th style={{ maxWidth: "100px" }}>Driver Name </th>
                      <th style={{ maxWidth: "100px" }}>Driver Phone</th>
                      <th style={{ maxWidth: "200px" }}>Status</th>
                      <th style={{ maxWidth: "130px" }}>ServiceType </th>
                      <th>Entrydate</th>
                      <th style={{ maxWidth: "100px" }}>From Loc</th>
                      <th style={{ maxWidth: "100px" }}>To Loc</th>
                      <th style={{ maxWidth: "70px" }}>Make </th>
                      <th style={{ maxWidth: "70px" }}>Model</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ordersToDisplay &&
                      ordersToDisplay?.map(
                        (serviceOrder: any, index: number) => (
                          <tr key={index}>
                            {!isAFLUser && (
                              <td className="table-action-btn">
                                <Dropdown onClick={(e) => e.stopPropagation()}>
                                  <Dropdown.Toggle
                                    variant="success"
                                    id="dropdown-basic"
                                    className="Dropdown-table"
                                  >
                                    <MoreVertIcon
                                      style={{
                                        color: "#333134",
                                        fontSize: "20px",
                                      }}
                                    />
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu className="Dropdown-table-item border-none">
                                    {serviceOrder?.aaaServiceRequestModel
                                      ?.state === "initiate" && (
                                      <>
                                        <Dropdown.Item
                                          className="Dropdown-table-list Dropdown-table-border-top border-none"
                                          onClick={() =>
                                            handleDeleteItem(
                                              serviceOrder?.orderView?.orderId
                                            )
                                          }
                                        >
                                          Cancel
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          as={Link}
                                          to={`/dashboard/servicelist/rescheduledate?OrderId=${serviceOrder.orderView.orderId}`}
                                          className="Dropdown-table-list Dropdown-table-border-bottom border-none"
                                        >
                                          Reschedule
                                        </Dropdown.Item>
                                      </>
                                    )}

                                    <Dropdown.Item
                                      as={Link}
                                      to={`/dashboard/servicelist/servicedetails?OrderId=${serviceOrder.orderView.orderId}&page=${currentPage}&size=${pageSize}`}
                                      className="Dropdown-table-list Dropdown-table-border-bottom border-none"
                                    >
                                      View Details
                                    </Dropdown.Item>

                                    {isAAAUser &&
                                      serviceOrder?.aaaServiceRequestModel
                                        ?.state === "reach" &&
                                      (!serviceOrder?.orderView
                                        ?.deliveryPartnerId ||
                                        serviceOrder?.orderView
                                          ?.deliveryPartnerId === "") &&
                                      serviceOrder?.orderServiceDetailsModel
                                        ?.serviceType === "DISTANCE_BASED" && (
                                        <Dropdown.Item
                                          as={Link}
                                          to={`/dashboard/servicelist/changeservice?OrderId=${serviceOrder.orderView.orderId}&page=${currentPage}&size=${pageSize}`}
                                          className="Dropdown-table-list Dropdown-table-border-bottom border-none"
                                        >
                                          Change Service
                                        </Dropdown.Item>
                                      )}
                                    {isAAAUser &&
                                      serviceOrder?.aaaServiceRequestModel
                                        ?.state === "reach" &&
                                      (!serviceOrder?.orderView
                                        ?.deliveryPartnerId ||
                                        serviceOrder?.orderView
                                          ?.deliveryPartnerId === "") && (
                                        <Dropdown.Item
                                          as={Link}
                                          to={`/dashboard/servicelist/editServiceDetails?OrderId=${serviceOrder.orderView.orderId}&page=${currentPage}&size=${pageSize}`}
                                          className="Dropdown-table-list Dropdown-table-border-bottom border-none"
                                        >
                                          Edit Details
                                        </Dropdown.Item>
                                      )}
                                    {isAAAUser &&
                                      serviceOrder?.aaaServiceRequestModel
                                        ?.state === "start" &&
                                      (!serviceOrder?.orderView
                                        ?.deliveryPartnerId ||
                                        serviceOrder?.orderView
                                          ?.deliveryPartnerId === "") && (
                                        <Dropdown.Item
                                          as={Link}
                                          to={`/dashboard/servicelist/editTimeline?OrderId=${serviceOrder.orderView.orderId}&page=${currentPage}&size=${pageSize}`}
                                          className="Dropdown-table-list Dropdown-table-border-bottom border-none"
                                        >
                                          Edit Time
                                        </Dropdown.Item>
                                      )}
                                    {isAAAUser &&
                                      ([
                                        "start",
                                        "reach",
                                        "done",
                                        "completed_by_driver",
                                      ].includes(
                                        serviceOrder?.aaaServiceRequestModel
                                          ?.state
                                      ) ||
                                        serviceOrder?.orderServiceDetailsModel
                                          ?.isDriverReachedAndCancelled) && (
                                        <Dropdown.Item
                                          as={Link}
                                          to={`/dashboard/servicelist/editImages?OrderId=${serviceOrder.orderView.orderId}&page=${currentPage}&size=${pageSize}`}
                                          className="Dropdown-table-list Dropdown-border-bottom border-none"
                                        >
                                          Images Edit
                                        </Dropdown.Item>
                                      )}
                                    {isAAAUser &&
                                      ([
                                        "start",
                                        "reach",
                                        "done",
                                        "completed_by_driver",
                                        "cancel",
                                        "dispatch",
                                      ].includes(
                                        serviceOrder?.aaaServiceRequestModel
                                          ?.state
                                      ) ||
                                        serviceOrder?.orderServiceDetailsModel
                                          ?.isDriverReachedAndCancelled) && (
                                        <Dropdown.Item
                                          as={Link}
                                          to={`/dashboard/servicelist/addComment?OrderId=${serviceOrder.orderView.orderId}&page=${currentPage}&size=${pageSize}`}
                                          className="Dropdown-table-list Dropdown-border-bottom border-none"
                                        >
                                          Add Comment
                                        </Dropdown.Item>
                                      )}
                                  </Dropdown.Menu>
                                </Dropdown>
                              </td>
                            )}
                            <td>{serviceOrder?.sequence}</td>
                            <td
                              style={{
                                maxWidth: "100px",
                                cursor: isAFLUser ? "pointer" : "default",
                                color: isAFLUser ? "#0d6efd" : "inherit",
                                textDecoration: isAFLUser
                                  ? "underline"
                                  : "none",
                              }}
                              onClick={() =>
                                isAFLUser &&
                                navigate(
                                  `/dashboard/servicelist/servicedetails?OrderId=${serviceOrder.orderView.orderId}&page=${currentPage}&size=${pageSize}`
                                )
                              }
                            >
                              {
                                serviceOrder?.orderServiceDetailsModel
                                  ?.referenceNumber
                              }
                            </td>
                            <td style={{ maxWidth: "100px" }}>
                              {serviceOrder?.orderView?.customer_name}
                            </td>
                            <td style={{ maxWidth: "100px" }}>
                              {serviceOrder?.orderView?.customer_phone_number}
                            </td>
                            <td style={{ maxWidth: "100px" }}>
                              {(
                                serviceOrder?.aaaServiceRequestModel
                                  ?.driverName ||
                                `${
                                  serviceOrder?.orderView?.delivery_boy_details
                                    ?.firstName || ""
                                } ${
                                  serviceOrder?.orderView?.delivery_boy_details
                                    ?.lastName || ""
                                }`
                              ).trim()}
                            </td>

                            <td style={{ maxWidth: "100px" }}>
                              {serviceOrder?.aaaServiceRequestModel
                                ?.driverPhone ||
                                serviceOrder?.orderView?.delivery_boy_details
                                  ?.phoneNumber}
                            </td>

                            <td style={{ maxWidth: "200px" }}>
                              <div className="d-flex align-items-center">
                                <span
                                  className="badge rounded-pill me-2"
                                  style={getStatusStyle(serviceOrder)}
                                >
                                  {getStatusText(serviceOrder, isAFLUser) ===
                                  "R&C"
                                    ? "R&C"
                                    : capitalize(
                                        getStatusText(serviceOrder, isAFLUser)
                                      )}
                                </span>
                                {serviceOrder && isAAAUser && (
                                  <span>
                                    {(() => {
                                      const {
                                        firstStarColor,
                                        secondStarColor,
                                      } = getStarColors(serviceOrder);
                                      return (
                                        <>
                                          <span
                                            className={`${firstStarColor} me-1`}
                                          >
                                            ★
                                          </span>
                                          <span className={secondStarColor}>
                                            ★
                                          </span>
                                        </>
                                      );
                                    })()}
                                  </span>
                                )}
                              </div>
                            </td>
                            <td style={{ maxWidth: "130px" }}>
                              {capitalize(
                                serviceOrder?.orderServiceDetailsModel
                                  ?.serviceName || ""
                              )}
                            </td>
                            <td>
                              {formatDate(serviceOrder?.orderView?.createdAt)}
                            </td>

                            {serviceOrder?.orderView?.recollection_location ? (
                              <>
                                <td style={{ maxWidth: "100px" }}>
                                  {
                                    serviceOrder?.orderView?.delivery_location
                                      ?.address
                                  }
                                </td>
                                <td style={{ maxWidth: "100px" }}>
                                  {
                                    serviceOrder?.orderView
                                      ?.recollection_location?.address
                                  }
                                </td>
                              </>
                            ) : (
                              <>
                                <td style={{ maxWidth: "100px" }}></td>
                                <td style={{ maxWidth: "100px" }}>
                                  {
                                    serviceOrder?.orderView?.delivery_location
                                      ?.address
                                  }
                                </td>
                              </>
                            )}

                            {/* <td>
                              {serviceOrder?.aaaServiceRequestModel?.state}
                            </td> */}

                            <td style={{ maxWidth: "70px" }}>
                              {capitalize(
                                serviceOrder?.orderServiceDetailsModel
                                  ?.vehicleMake || ""
                              )}
                            </td>
                            <td style={{ maxWidth: "70px" }}>
                              {capitalize(
                                serviceOrder?.orderServiceDetailsModel
                                  ?.carModel || ""
                              )}
                            </td>
                          </tr>
                        )
                      )}
                  </tbody>
                </table>
              </div>
              <div className="text-end">
                <div className="flex items-center gap-2 justify-content-end">
                  <select
                    value={pageSize}
                    onChange={handlePageSizeChange}
                    className="px-2 py-1 border rounded mx-1"
                  >
                    {[5, 10, 20, 25, 50].map((size) => (
                      <option key={size} value={size}>
                        {size}
                      </option>
                    ))}
                  </select>
                  <button
                    onClick={() =>
                      searchResults
                        ? handlePageSearchChange(currentSearchPage - 1)
                        : handlePageChange(currentPage - 1)
                    }
                    disabled={
                      searchResults
                        ? currentSearchPage === 0
                        : currentPage === 0
                    }
                    className="px-3 py-1 border rounded disabled:opacity-50 mx-1"
                  >
                    Previous
                  </button>
                  {(searchResults ? searchVisiblePages : visiblePages).map(
                    (page, index) =>
                      page === -1 ? (
                        <span key={index} className="px-2">
                          ...
                        </span>
                      ) : (
                        <button
                          key={index}
                          onClick={() =>
                            searchResults
                              ? handlePageSearchChange(page)
                              : handlePageChange(page)
                          }
                          className={`px-3 py-1 border rounded mx-1 ${
                            (searchResults
                              ? currentSearchPage
                              : currentPage) === page
                              ? "current-page"
                              : ""
                          }`}
                        >
                          {page + 1}
                        </button>
                      )
                  )}
                  <button
                    onClick={() =>
                      searchResults
                        ? handlePageSearchChange(currentSearchPage + 1)
                        : handlePageChange(currentPage + 1)
                    }
                    disabled={
                      searchResults
                        ? currentSearchPage >=
                          (searchResults?.totalPages || 0) - 1
                        : currentPage >= totalPages - 1
                    }
                    className="px-3 py-1 border rounded disabled:opacity-50 mx-1"
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
      <AFLConfirmationModal
        isOpen={showAcceptConfirmationModal}
        onClose={() => setShowAcceptConfirmationModal(false)}
        onConfirm={() => {
          if (selectedOrderId) {
            mutationDelete.mutate(selectedOrderId);
          }
          setShowAcceptConfirmationModal(false);
        }}
        message={acceptConfirmationMessage}
      />
    </div>
  );
};

interface ServiceOrder {
  orderServiceDetailsModel?: {
    isDriverReachedAndCancelled?: boolean;
    serviceName?: string;
    referenceNumber?: string;
  };
  aaaServiceRequestModel?: {
    state: string;
  };
  orderView?: {
    customer_name?: string;
    customer_phone_number?: string;
    delivery_boy_details?: {
      firstName?: string;
      phoneNumber?: string;
    };
    createdAt?: string;
    recollection_location?: any;
    delivery_location?: any;
    sequence?: string;
  };
}

const getStatusStyle = (serviceOrder: ServiceOrder) => {
  const status = serviceOrder?.aaaServiceRequestModel?.state;
  const isDriverReachedAndCancelled =
    serviceOrder?.orderServiceDetailsModel?.isDriverReachedAndCancelled;

  // Default style
  const style = {
    backgroundColor: "#e0e0e0",
    color: "#000000",
    fontSize: "12px",
  };

  // For cancelled states
  if (
    isDriverReachedAndCancelled ||
    status === "cancel" ||
    status === "reached_and_cancelled" ||
    status === "driver_cancel"
  ) {
    return {
      ...style,
      backgroundColor: "#ffcdd2",
      color: "#000000",
    };
  }

  switch (status) {
    case "initiate":
      return {
        ...style,
        backgroundColor: "#bbdefb",
        color: "#000000",
      };
    case "dispatch":
      return {
        ...style,
        backgroundColor: "#c8e6c9",
        color: "#000000",
      };
    case "start":
      return {
        ...style,
        backgroundColor: "#fff9c4",
        color: "#000000",
      };
    case "reach":
      return {
        ...style,
        backgroundColor: "#c8e6c9",
        color: "#000000",
      };
    case "completed_by_driver":
      return {
        ...style,
        backgroundColor: "#c8e6c9",
        color: "#000000",
      };
    case "done":
      return {
        ...style,
        backgroundColor: "#c8e6c9",
        color: "#000000",
      };
    case "cancel":
      return {
        ...style,
        backgroundColor: "#ffcdd2",
        color: "#000000",
      };
    case "reached_and_cancelled":
      return {
        ...style,
        backgroundColor: "#ffcdd2",
        color: "#000000",
      };
    default:
      return style;
  }
};

const getStatusText = (serviceOrder: ServiceOrder, isAFLUser: boolean) => {
  const state = serviceOrder?.aaaServiceRequestModel?.state;
  const isDriverReachedAndCancelled =
    serviceOrder?.orderServiceDetailsModel?.isDriverReachedAndCancelled;

  // Handle AFL user cases first
  if (isAFLUser && state === "driver_cancel") {
    return isDriverReachedAndCancelled ? "R&C" : "Cancelled";
  }

  // Handle reached and cancelled cases for non-AFL users
  if (isDriverReachedAndCancelled) {
    if (state === "cancel") {
      return "R&C";
    }
    if (state === "driver_cancel" && !isAFLUser) {
      return "Driver Cancel Pending";
    }
  }

  // For AFL users, show 'Cancelled' for cancelled states
  if (isAFLUser && (state === "driver_cancel" || state === "cancel")) {
    return "Cancelled";
  }

  // For non-AFL users, show 'Driver Cancel Pending' when state is 'driver_cancel' and not reached and cancelled
  if (!isAFLUser && state === "driver_cancel" && !isDriverReachedAndCancelled) {
    return "Driver Cancel Pending";
  }

  const status = serviceOrder?.aaaServiceRequestModel?.state;
  switch (status) {
    case "completed_by_driver":
      return "Completed";
    case "reached_and_cancelled":
      return "R&C";
    case "driver_cancel":
      return "Driver Cancel";
    default:
      return status || "N/A";
  }
};

export default ServiceList;
